<template>
  <div>
    <TheHeader :key="$route.fullPath"></TheHeader>

    <IeMessage v-if="$store.getters.isIE" />

    <main class="content configurator" v-else>
      <div class="componata-container">
        <transition name="modal-backdrop-transition" appear>
          <router-view />
        </transition>
      </div>
    </main>

    <TheFooter></TheFooter>

    <ModalProduct v-if="$store.getters.getModalOpen && !$store.getters.isIE" />

    <ShoppingSetupModal v-if="showSetupModal && $route.name && !$store.getters.isIE" />

    <TheLoader v-if="$store.getters.getGlobalLoading && !$store.getters.isIE" />
  </div>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';
import IeMessage from '@/views/Common/IeMessage';
import TheHeader from '@/components/TheHeader';
import TheFooter from '@/components/TheFooter';
import ModalProduct from '@/components/ModalProduct';
import ShoppingSetupModal from '@/components/Configurator/ShoppingSetupModal';
import TheLoader from '@/components/TheLoader';

export default {
  data() {
    return {
      showSetupModal: false
    };
  },
  mixins: [logicMixin],
  components: {
    IeMessage,
    TheHeader,
    TheFooter,
    ModalProduct,
    ShoppingSetupModal,
    TheLoader
  },
  mounted() {
    this.$root.$on('showSetupModal', () => {
      const show = localStorage.getItem('setupModal');

      if (show === null) {
        this.showSetupModal = true;
        localStorage.setItem('setupModal', true);
      }
    });

    if (!(this.$route.path.startsWith('/b2c') || this.$route.path.startsWith('/b2b'))) {
      const show = localStorage.getItem('typeChooser');
      if (show === null) {
      } else {
        this.$router.push(this.cLink(this.$route.path));
      }
    } else {
      localStorage.setItem('typeChooser', true);
    }

    this.$root.$on('closeSetupModal', () => {
      this.showSetupModal = false;
    });
  }
};
</script>

<style lang="scss" scoped>
  .configurator {
    background-color: $sky-light;
  }
</style>
